module.exports = __webpack_public_path__ + "img/printer-label-brother3.6a0904f1.jpg";